import { GlobalSettingEnum } from 'api/model';
import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';
import useGlobalSettings from './useGlobalSettings';

/**
 * Tillgång till Riddermarks rapportering: sidan /ledningsrapport och widgetarna under
 * /nyckeltal-riddermark.
 *
 * De två ytorna delar lista med flit. Det är samma sju tal i två former — rapporten är dem
 * sammanställda för läsning, RM-nyckeltal är dem att gräva i — så att kunna ge någon den ena
 * utan den andra vore att gömma slutsatsen men lämna underlaget framme.
 *
 * Den här hooken styr bara vad som SYNS. Den riktiga spärren sitter i KPIController och
 * ExportController, som prövar samma inställning på servern: att dölja ett menyval hindrar ingen
 * som skriver in adressen direkt.
 */
const useHasAccessToRiddermarkReporting = () => {
  const me = useMe();
  const { parsedData: globalSettings, loaded } = useGlobalSettings();

  return useMemo(() => {
    if (!me || !loaded) {
      return false;
    }

    const allowedUsers =
      globalSettings[GlobalSettingEnum.UsersWithAccessToRiddermarkReporting];

    // Tom lista = dolt för alla, också för SuperAdmin. Funktionen ska slås på uttryckligen,
    // inte råka vara på.
    if (Object.keys(allowedUsers).length === 0) {
      return false;
    }

    return allowedUsers[me.userID] === true;
  }, [me, globalSettings, loaded]);
};

export default useHasAccessToRiddermarkReporting;
